
if(!__webpack_require__.federation){
    __webpack_require__.federation = {
        
chunkMatcher: function(chunkId) {
    return !/^(5(086|274|630|916|979)|6(142|510|758)|(775|913|963)9|1526|1852|3601|4377|7665)$/.test(chunkId);
},
rootOutputDir: "",

    };
}
